import { render, staticRenderFns } from "./wkb.vue?vue&type=template&id=1e88ae0c&scoped=true"
import script from "./wkb.vue?vue&type=script&lang=js"
export * from "./wkb.vue?vue&type=script&lang=js"
import style0 from "./wkb.vue?vue&type=style&index=0&id=1e88ae0c&prod&scoped=true&lang=css"
import style1 from "./wkb.vue?vue&type=style&index=1&id=1e88ae0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e88ae0c",
  null
  
)

export default component.exports